export default `
mutation setClientPassword($id: ID!, $password: String!, $serviceProviderId: ID!) {
  setClientPassword(id: $id, password: $password, serviceProviderId: $serviceProviderId) {
    id
    serviceProviderId
    updatedAt
    propertyIds
    firstName
    lastName
    email
    isArchived
    isDeleted
  }
}
`;
